jQuery( ".faq-left button" ).click(function() {
	
	var topic = jQuery(this).data('topic');
	
	var elem = '.accordion-item[data-topic="' + topic + '"]';
	
	if( topic == 'all' ) {
	
		jQuery('.accordion-item').show();
		
	}
	
	else {
		
		jQuery('.accordion-item').hide();
		jQuery( elem ).show();
	
	}
	
	jQuery('.faq-left button.active').removeClass('active');
	
	jQuery(this).addClass('active');
  
});